import {
  Breadcrumbs,
  Paper,
  Button,
  Container,
  Group,
  Select,
  Textarea,
  TextInput,
  Text,
  SelectItem,
  SimpleGrid,
  Checkbox,
  Stack,
  Tooltip,
  Modal,
  Title,
  Anchor,
  ScrollArea,
  SelectItemProps,
  Radio,
  Divider,
  Grid,
  Col,
  Box,
} from "@mantine/core";
import { DateInput } from "@mantine/dates";
import {
  Timestamp,
  addDoc,
  updateDoc,
  collection,
  collectionGroup,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  serverTimestamp,
  where,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../../firebase/FirebaseCredential";
import { Link, useNavigate, useParams } from "react-router-dom";
import { IconCirclePlus, IconHome, IconInfoCircle } from "@tabler/icons-react";
import { logError } from "../ErrorLogService/ErrorLoggingService";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";
import BenchLoader from "../UIComponent/BenchLoader/BenchLoader";
import PermissionButton from "../PermissionComponent/PermissionButton";
import { useAppSelector } from "../../hooks/hooks";
import { RootState } from "../../store/store";
import { showToast } from "../Utils/toastHelper";
import { ROUTES } from "../../routes/routesPaths";
import BenchBreadcrumbs from "../UIComponent/Components/BenchBreadcrumbs";
import BenchCard from "../UIComponent/Components/BenchCard";
import BenchHeading from "../pages/UI/BenchHeading";
import { useUserContext } from "../../contextapi/UserContext";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
interface BankingAccount {
  accountName: string;
  accountType: string; // e.g., "bank_account" or "credit_card"
  currency: string; // e.g., "INR"
  description: string;
  nickname: string;
  created_at: any;
}

interface CustomSelectItemProps extends SelectItemProps {
  label: string;
  level: number;
}
// Custom item component with dynamic padding
const CustomSelectItem = ({
  label,
  level,
  value,
  ...others
}: CustomSelectItemProps) => (
  <div {...others}>
    <Group noWrap>
      {/* Show icon only for specific values */}
      {value === "add_new" || value === "add_new_paid_through" ? (
        <IconCirclePlus stroke={2} color="green" />
      ) : null}

      <Text
        style={{
          paddingLeft: `${10 + level * 40}px !important`, // 10px default + dynamic padding based on level
        }}
      >
        {label}
      </Text>
    </Group>
  </div>
);

interface FormValues {
  expense_name: string;
  type: string;
  amount: string;
  description: string;
  vendor_id: string;
  vendor_name: string;
  expense_account_name: string;
  expense_account_id: string;
  frequency: string;
}

const initialValues: FormValues = {
  expense_name: "",
  type: "expense",
  amount: "",
  description: "",
  vendor_id: "",
  vendor_name: "",
  expense_account_name: "",
  expense_account_id: "",
  frequency: "monthly",
};

export default function RecuringExpenses() {
  const companyId = useAppSelector(
    (state: RootState) => state.session.company_id
  );
  const { profileDetails } = useUserContext();

  const validateForm = () => {
    if (!TransactionFormValues.expense_name) {
      toast.warn("Please enter an expense name");
      return false;
    }

    if (!startDate) {
      toast.warn("Please select a start date");
      return false;
    }

    if (!BranchId) {
      toast.warn("Please select a branch");
      return false;
    }

    if (
      !TransactionFormValues.amount ||
      Number(TransactionFormValues.amount) <= 0
    ) {
      toast.warn("Please enter a valid amount");
      return false;
    }

    if (!ExpenseAccountID) {
      toast.warn("Please select an expense category");
      return false;
    }



    return true;
  };

  const {
    branchesList,
    loading: branchLoading,
    error,
  } = useAppSelector((state) => state.branchList);

  const [TransactionFormValues, setTransactionFormValues] =
    useState<FormValues>(initialValues);
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [BranchId, setBranchId] = useState<string | null>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [expensesAccountList, setExpensesAccountList] = useState<any>([]);
  const [paymentAccountList, setPaymentAccountList] = useState<any>([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [modalOpened, setModalOpened] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [vendorNumber, setVendorNumber] = useState(""); // Auto-generated
  const [phone, setPhone] = useState("");
  const [gstTreatment, setGstTreatment] = useState<any>("");
  const [gstin, setGstin] = useState("");
  const [sourceOfSupply, setSourceOfSupply] = useState("");
  const [pan, setPan] = useState("");
  const [modalBankingOpened, setModalBankingOpened] = useState(false);
  const [accountType, setAccountType] = useState("bank_account");
  const [accountName, setAccountName] = useState("");
  const [nickname, setNickname] = useState("");
  const [currency, setCurrency] = useState("INR");
  const [description, setDescription] = useState("");

  const [vendorData, setVendorData] = useState<any[]>([]);
  const [paidThrouhID, setPaidThrouhID] = useState<any>("");
  const [ExpenseAccountID, setExpenseAccountID] = useState<any>("");
  const [isPageLoading, setIsPageLoading] = useState(false);

  const navigate = useNavigate();
  const { transactionId } = useParams<{ transactionId: string }>();

  useEffect(() => {
    if (companyId) {
      // fetchBranches();
      fetchExpenseAccounts();
      fetchVendorAccounts();
      fetchBankingData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  useEffect(() => {
    if (transactionId && companyId) {
      fetchExpenseData();
    }
  }, [transactionId, companyId]);

  const fetchExpenseData = async () => {
    try {
      setIsPageLoading(true);
      const docRef = doc(db, "companyprofile", companyId as string, "recurringexpenses", transactionId as string);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setTransactionFormValues({
          expense_name: data.expense_name || "",
          type: data.type || "expense",
          amount: data.amount ? data.amount.toString() : "",
          description: data.description || "",
          vendor_id: data.vendor_id || "",
          vendor_name: data.vendor_name || "",
          expense_account_name: data.expense_account_name || "",
          expense_account_id: data.expense_account_id || "",
          frequency: data.frequency || "monthly",
        });
        setStartDate(data.start_date ? data.start_date.toDate() : null);
        setEndDate(data.end_date ? data.end_date.toDate() : null);
        setBranchId(data.branch_id);
        setExpenseAccountID(data.expense_account_id);
        setSelectedVendor(data.vendor_id);
      }
    } catch (err) {
      console.error(err);
      logError(err, "fetchExpenseData RecuringExpenses");
    } finally {
      setIsPageLoading(false);
    }
  };

  const fetchExpenseAccounts = async () => {
    try {
      const q = query(
        collectionGroup(db, "expenseaccounts"),
        where("company_id", "==", companyId)
      );

      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const expenseData = querySnapshot?.docs?.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setExpensesAccountList(expenseData);
        // console.log("Expense account:", expenseData);
      } else {
        console.log("No matching documents found.");
      }
    } catch (error) {
      console.error("Error fetching expense accounts:", error);
      logError(error, "fetchExpenseAccounts AddTransactionPage");
    }
  };
  const fetchVendorAccounts = async () => {
    try {
      const q = query(
        collectionGroup(db, "vendoraccounts"),
        where("company_id", "==", companyId)
      );

      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const vendorData = querySnapshot?.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        console.log("vendor account:", vendorData);
        setVendorData(vendorData);
      } else {
        console.log("No matching documents found.");
      }
    } catch (error) {
      console.error("Error fetching vendor accounts:", error);
      logError(error, "fetchVendorAccounts AddTransactionPage");
    }
  };

  const handleAddExpenseDoc = async () => {
    try {
      if (!validateForm()) return;

      // Convert dates to Firebase Timestamp
      const startTimestamp = startDate ? Timestamp.fromDate(startDate) : null;
      const endTimestamp = endDate ? Timestamp.fromDate(endDate) : null;
      
      // Get the selected branch name from filterList
      const selectedBranch = branchesList.find(
        (branch: { id: string | null | undefined }) => branch.id === BranchId
      );
      const branchName = selectedBranch?.name;
      // const selectedpaidAccountName = paymentAccountList.find(
      //   (item: { id: string }) =>
      //     item.id === TransactionFormValues.paid_through_id
      // );
      const selectedExpenseAccount = expensesAccountList.find(
        (item: { id: string }) => item.id === ExpenseAccountID
      );
      const selectedPaidThroughData = paymentAccountList.find(
        (item: { id: string; value: string }) =>
          item.id === paidThrouhID || item.value === paidThrouhID
      );
      const selectedVendorData = vendorData.find(
        (item: { id: string }) => item.id === selectedVendor
      );
      setIsPageLoading(true);

      // Create the document structure
      const newTransaction: any = {
        ...TransactionFormValues,
        start_date: startTimestamp,
        end_date: endTimestamp,
        company_id: companyId,
        branch_id: BranchId,
        branch_name: branchName,
        expense_account_name: selectedExpenseAccount.label,
        expense_account_id: ExpenseAccountID,

        vendor_id: selectedVendor || "",
        vendor_name: selectedVendorData
          ? `${selectedVendorData.firstName || ""} ${selectedVendorData.lastName || ""}`.trim()
          : "",
      };

      if (!transactionId) {
        newTransaction.next_action_date = startTimestamp; // Initial next action date is the start date
        newTransaction.status = "Active";
        newTransaction.created_at = serverTimestamp();
        newTransaction.created_by = profileDetails ? (`${profileDetails.first_name || ""} ${profileDetails.last_name || ""}`.trim() || profileDetails.first_name || "System") : "System";

        await addDoc(collection(db, "companyprofile", companyId, "recurringexpenses"), newTransaction).then(() => {
          navigate("/recurring-expenses");
        });
        console.log("Transaction successfully added:", newTransaction);
      } else {
        newTransaction.updated_at = serverTimestamp();
        await updateDoc(doc(db, "companyprofile", companyId, "recurringexpenses", transactionId), newTransaction).then(() => {
          navigate("/recurring-expenses");
        });
        console.log("Transaction successfully updated:", newTransaction);
      }
      setTransactionFormValues(initialValues);
    } catch (error) {
      console.error("Error adding transaction:", error);
      logError(error, "handleAddExpenseDoc AddTransactionPage");
    } finally {
      setIsPageLoading(false);
    }
  };
  const fetchBankingData = async () => {
    try {
      if (!companyId) {
        console.error("Error: companyId is required to fetch banking data.");
        return;
      }

      // Fetch banking data from Firestore
      const companySettingsRef = collectionGroup(db, "banking");
      const q = query(companySettingsRef, where("company_id", "==", companyId));

      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const bankingData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Log fetched banking data
        console.log("Banking data fetched successfully:", bankingData);

        // Set the payment account list with the fetched banking data
        setPaymentAccountList(bankingData);
      } else {
        console.log("No banking document found for the specified company.");
        setPaymentAccountList([]); // Handle no document case
      }

      // Fetch Cash Payment Data
      const cashDocRef = query(
        collectionGroup(db, "paymentcollection"),
        where("type", "==", "cash"),
        where("company_id", "==", companyId),
        limit(1)
      );

      // Fetch cash document snapshot
      const cashDocSnap = await getDocs(cashDocRef);

      if (!cashDocSnap.empty) {
        const doc = cashDocSnap.docs[0];
        console.log(doc.id, doc.data());
        const cashData = doc.data();
        console.log("Cash Payment Data:", cashData);

        const isEnabled = cashData?.status === "Active";
        console.log("Is Cash Payment Enabled?", isEnabled);

        if (isEnabled) {
          // If Cash Payment is enabled, push into payment account list
          const cashAccount = {
            value: "petty_cash",
            label: "Petty Cash",
          };

          // setPaymentAccountList((prevList: any) => [
          //   ...prevList,
          //   cashAccount, // Add cash account data to the list
          // ]);
          // Prevent duplication by checking if "Petty Cash" already exists in the list
          setPaymentAccountList((prevList: any[]) => {
            // Check if the "Petty Cash" already exists in the list
            const exists = prevList.some((item) => item.value === "petty_cash");

            // Only add "Petty Cash" if it doesn't already exist in the list
            if (exists) {
              return prevList;
            }

            // Otherwise, add "Petty Cash" to the list
            return [...prevList, cashAccount];
          });
        }
      } else {
        console.log("No Cash Payment document found.");
      }
    } catch (error) {
      console.error("Error fetching banking data:", error);
    }
  };

  // const fetchBankingData = async () => {
  //   try {
  //     if (!companyId) {
  //       console.error("Error: companyId is required to fetch banking data.");
  //       return;
  //     }

  //     const companySettingsRef = collectionGroup(db, "banking");
  //     const q = query(
  //       companySettingsRef,
  //       where("company_id", "==", companyId)
  //       // where("doc_type", "==", "banking")
  //     );

  //     const querySnapshot = await getDocs(q);

  //     if (!querySnapshot.empty) {
  //       const bankingData = querySnapshot.docs.map((doc) => ({
  //         id: doc.id,
  //         ...doc.data(),
  //       }));
  //       // const bankingData: DocumentData = bankingDoc.data();
  //       // const formattedBankingData: BankingData = {
  //       //   account_list: bankingData, // Ensure account_list is defined
  //       // };
  //       console.log("Banking data fetched successfully:", bankingData);
  //       setPaymentAccountList(bankingData);
  //     } else {
  //       console.log("No banking document found for the specified company.");
  //       setPaymentAccountList([]); // Handle no document case
  //     }
  //   } catch (error) {
  //     console.error("Error fetching banking data:", error);
  //   }
  // };
  const saveBankingAccount = async () => {
    try {
      if (!companyId) {
        console.error("Company ID is required.");
        return;
      }
      setIsPageLoading(true);

      const newBankingData: BankingAccount = {
        accountType,
        accountName,
        nickname,
        currency,
        description,
        created_at: serverTimestamp(),
      };

      const companyDocRef = doc(db, "companyprofile", companyId);
      const companySnapshot = await getDoc(companyDocRef);

      if (companySnapshot.exists()) {
        const bankingCollectionRef = collection(companyDocRef, "banking");

        // Add the new banking data as a separate document in the 'banking' sub-collection
        await addDoc(bankingCollectionRef, {
          ...newBankingData,
          company_id: companyId,
        });
        fetchBankingData();
        console.log("Banking data added successfully.");
      } else {
        console.log("Company document not found.");
      }
    } catch (error) {
      console.error("Error saving banking data: ", error);
      logError(error, "saveBankingAccount AddTransactionPage");
    } finally {
      setModalBankingOpened(false);
      setIsPageLoading(false);
    }
  };

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setTransactionFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleBranchChange = (value: string | null) => {
    setBranchId(value);
    if (value === "all") {
      console.log("All branches selected");
    } else {
      console.log(`Branch selected: ${value}`);
    }
  };
  // Custom component for select item rendering
  const SelectItemWithIcon = ({ label, value, ...others }: SelectItem) => (
    <div {...others}>
      <Group noWrap>
        {/* Show icon only for specific values */}
        {value === "add_new" ||
          value === "add_new_paid_through" ||
          value === "add_new_vendor_account" ? (
          <IconCirclePlus stroke={2} color="green" />
        ) : null}

        <Text>{label}</Text>
      </Group>
    </div>
  );

  const handleVendorChange = (value: any) => {
    if (value === "add_new_vendor_account") {
      setModalOpened(true);
    } else {
      setSelectedVendor(value);
    }
  };
  const handleCancelClick = () => {
    navigate("/recurring-expenses");
  };

  const handleAddVendor = async () => {
    try {
      // Basic validation
      if (!firstName.trim()) {
        toast.warn("First name is required");
        return;
      }

      if (emailAddress) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(emailAddress)) {
          toast.warn("Please enter a valid email address");
          return;
        }
      }

      if (phone) {
        const phoneRegex = /^[0-9]{10}$/;
        if (!phoneRegex.test(phone)) {
          toast.warn("Please enter a valid 10-digit phone number");
          return;
        }
      }

      if (pan) {
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        if (!panRegex.test(pan.toUpperCase())) {
          toast.warn("Please enter a valid PAN (e.g., ABCDE1234F)");
          return;
        }
      }

      const newVendor = {
        firstName,
        lastName,
        companyName,
        emailAddress,
        vendorNumber,
        phone,
        gstTreatment,
        gstin,
        sourceOfSupply,
        pan: pan.toUpperCase(),
        company_id: companyId,
      };
      setIsPageLoading(true);
      if (!companyId) {
        console.error("companyId is", companyId);
        return;
      }
      // Add the new expense account document
      const docRef = await addDoc(
        collection(
          db,
          "companyprofile",
          companyId,
          "companyconfig",
          "userAccountConfiguration",
          "vendoraccounts"
        ),
        newVendor
      );

      console.log("vendor account added with ID: ", docRef.id);

      // Close the modal and refresh the expense accounts list
      setIsModalOpen(false);
      setModalOpened(false);
      fetchVendorAccounts();

      toast.success("Vendor account added successfully!");
    } catch (error) {
      console.error("Error adding vendor account: ", error);
      logError(error, "handleAddVendor AddTransactionPage");
      toast.error("Failed to add vendor account. Please try again.");
    } finally {
      setIsPageLoading(false);
    }
  };
  // console.log(expensesAccountList, "expensesAccountList");
  const breadcrumbLinks = [
    {
      label: "Recurring Expense",
      path: "/recurring-expenses",
    },
    {
      label: transactionId ? "Edit Recurring Expense" : "Add Recurring Expense",
    },
  ];

  return (
    <div style={{ margin: "1%", padding: "1%" }}>
      <Container size={"lg"}> <Box
            sx={(theme) => ({
              position: "sticky",
              top: 110, // Avoid overlapping the fixed navbar
              zIndex: 100,
              backgroundColor: "#FAFAFA",
              paddingTop: theme.spacing.sm,
              //paddingBottom: theme.spacing.xs,
              marginTop: `-${theme.spacing.sm}`,
            })}
          >
        <SimpleGrid cols={2}>
          <BenchBreadcrumbs links={breadcrumbLinks} />
          <Group position="right">
            <Button variant="outline" onClick={handleCancelClick}>
              Cancel
            </Button>
            {/* <Button type="submit">Add</Button> */}
            <PermissionButton
              resourceId="expenses"
              actionType={transactionId ? "update" : "create"}
              label={transactionId ? "Update" : "Add"}
              form="expenseform"
              type="submit"
            />
          </Group>
        </SimpleGrid>
        <Divider my="sm" />
</Box>
        <BenchCard style={{ marginBottom: "40px" }}>
          <Group mb="md">
            <BenchHeading
              title={transactionId ? "Edit Recurring Expense" : "Add Recurring Expense"}
              subheading={transactionId ? "Update recurring business expense" : "Set up a new recurring business expense"}
              order={4}
              fw={600}
              fz="h1"
            />
          </Group>
          <Container>
            <ErrorBoundary>
              <form
                id="expenseform"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleAddExpenseDoc();
                }}
              >
                <Grid>
                  <Col span={12}>
                    <TextInput
                      name="expense_name"
                      value={TransactionFormValues?.expense_name}
                      onChange={handleInputChange}
                      label="Expense Name"
                      placeholder="e.g. Monthly Rent, Weekly Cleaning"
                      withAsterisk
                    />
                  </Col>
                  <Col span={12} lg={4}>
                    <Select
                      label="Frequency"
                      name="frequency"
                      value={TransactionFormValues.frequency}
                      onChange={(val) => setTransactionFormValues(prev => ({ ...prev, frequency: val || 'monthly' }))}
                      data={[
                        { value: 'daily', label: 'Daily' },
                        { value: 'weekly', label: 'Weekly' },
                        { value: 'monthly', label: 'Monthly' },
                        { value: 'yearly', label: 'Yearly' },
                      ]}
                      withAsterisk
                    />
                  </Col>
                  <Col span={12} lg={4}>
                    <DateInput
                      value={startDate}
                      onChange={setStartDate}
                      label="Start Date"
                      placeholder="Pick start date"
                      valueFormat="DD MMM YYYY"
                      withAsterisk
                    />
                  </Col>
                  <Col span={12} lg={4}>
                    <DateInput
                      value={endDate}
                      onChange={setEndDate}
                      label="End Date (Optional)"
                      placeholder="Never expires"
                      valueFormat="DD MMM YYYY"
                      clearable
                    />
                  </Col>
                  <Col span={12} lg={6}>
                    <Select
                      label={
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <span>Select Branch</span>
                          <Tooltip label="Choose the branch associated with this expense. This helps in tracking expenses per branch.">
                            <IconInfoCircle
                              stroke={1}
                              size={16}
                              style={{ cursor: "pointer" }}
                            />
                          </Tooltip>
                        </div>
                      }
                      value={BranchId}
                      onChange={(value) => handleBranchChange(value)}
                      data={
                        branchesList &&
                        branchesList
                          ?.filter((item: any) => item.id !== "all_branches")
                          ?.map((item: any) => ({
                            value: item.id,
                            label: item.name,
                          }))
                      }
                      withAsterisk
                      nothingFound
                      placeholder="Select Branch"
                    />
                  </Col>
                  <Col span={12} lg={6}>
                    <TextInput
                      name="amount"
                      value={TransactionFormValues?.amount}
                      onChange={handleInputChange}
                      label={
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <span>Amount</span>
                          <Tooltip label="Enter the total expense amount.">
                            <IconInfoCircle
                              stroke={1}
                              size={16}
                              style={{ cursor: "pointer" }}
                            />
                          </Tooltip>
                        </div>
                      }
                      withAsterisk
                      placeholder="Enter amount"
                      type="number"
                    />
                  </Col>
                  <Col span={12} lg={6}>
                    <Select
                      searchable
                      label={
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <span>Expense Category</span>
                          <Tooltip label="Select the category or account under which this expense falls (e.g., Office Supplies, Utilities, Rent).">
                            <IconInfoCircle
                              stroke={1}
                              size={16}
                              style={{ cursor: "pointer" }}
                            />
                          </Tooltip>
                        </div>
                      }
                      placeholder="Expense Account"
                      value={ExpenseAccountID}
                      // onChange={(e) => setValue(e)}
                      onChange={(value) => {
                        if (value === "add_new") {
                          setIsModalOpen(true);
                        } else {
                          setExpenseAccountID(value);
                        }
                      }}
                      dropdownComponent={ScrollArea} // Allows scrolling in the dropdown
                      itemComponent={CustomSelectItem} // Custom component for dropdown items
                      styles={(theme) => ({
                        dropdown: {
                          maxHeight: 400,
                          overflowY: "auto", // Ensure dropdown scrolls
                        },
                      })}
                      data={
                        expensesAccountList
                          ?.map(
                            (item: { id: any; label: any; group: string }) => ({
                              value: item.id,
                              label: item.label,
                              ...(item?.group && { group: item?.group }),
                            })
                          )
                          ?.concat([
                            {
                              value: "add_new",
                              label: "Add New Expense Category",
                            },
                          ]) || []
                      }
                      withAsterisk
                      nothingFound
                    />
                  </Col>

                  <Col span={12} lg={6}>
                    <Select
                      searchable
                      label={
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <span>Select Vendor</span>
                          <Tooltip label="Select the vendor or supplier associated with this expense, if applicable.">
                            <IconInfoCircle
                              stroke={1}
                              size={16}
                              style={{ cursor: "pointer" }}
                            />
                          </Tooltip>
                        </div>
                      }
                      placeholder="Choose a vendor"
                      value={selectedVendor}
                      onChange={handleVendorChange}
                      data={
                        vendorData
                          ?.map((account: any) => ({
                            value: account?.id,
                            label: account?.firstName,
                          }))
                          .concat([
                            {
                              value: "add_new_vendor_account",
                              label: "Add New Vendor Account",
                            },
                          ]) || []
                      }
                      itemComponent={SelectItemWithIcon}
                      nothingFound
                    />
                  </Col>
                  <Col span={12}>
                    <Textarea
                      name="description"
                      label={
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <span>Description</span>
                          <Tooltip label="Provide additional details or notes about this expense for future reference.">
                            <IconInfoCircle
                              stroke={1}
                              size={16}
                              style={{ cursor: "pointer" }}
                            />
                          </Tooltip>
                        </div>
                      }
                      value={TransactionFormValues?.description}
                      onChange={handleInputChange}
                      placeholder="Enter description"
                    />
                  </Col>
                </Grid>
              </form>
            </ErrorBoundary>
          </Container>
        </BenchCard>
      </Container>
      <Modal
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
        title={
          <>
            <Title order={4} weight={500}>
              Add New Vendor
            </Title>
          </>
        }
        size={"lg"}
        closeOnClickOutside={false}
        closeButtonProps={{
          iconSize: "52",
        }}
      >
        {" "}
        <Container>
          <TextInput
            label="First Name"
            placeholder="Enter first name"
            value={firstName}
            onChange={(event) => setFirstName(event.currentTarget.value)}
          />
          <TextInput
            label="Last Name"
            placeholder="Enter last name"
            value={lastName}
            onChange={(event) => setLastName(event.currentTarget.value)}
          />
          <TextInput
            label="Company Name"
            placeholder="Enter company name"
            value={companyName}
            onChange={(event) => setCompanyName(event.currentTarget.value)}
          />
          <TextInput
            label="Email Address"
            placeholder="Enter email address"
            value={emailAddress}
            onChange={(event) => setEmailAddress(event.currentTarget.value)}
          />

          <TextInput
            label="Phone"
            placeholder="Enter phone number"
            value={phone}
            onChange={(event) => setPhone(event.currentTarget.value)}
          />
          <Select
            label="GST Treatment"
            placeholder="Select GST treatment"
            value={gstTreatment}
            onChange={setGstTreatment}
            data={gstOptions}
            nothingFound
          />
          {gstTreatment === "registered" && (
            <TextInput
              label="GSTIN / UIN"
              placeholder="Enter GSTIN / UIN"
              value={gstin}
              onChange={(event) => setGstin(event.currentTarget.value)}
            />
          )}
          <TextInput
            label="Source Of Supply"
            placeholder="Enter source of supply"
            value={sourceOfSupply}
            onChange={(event) => setSourceOfSupply(event.currentTarget.value)}
          />
          <TextInput
            label="PAN"
            placeholder="Enter PAN"
            value={pan}
            onChange={(event) => setPan(event.currentTarget.value)}
          />

          <Group mt="md">
            <Button variant="outline" onClick={() => setModalOpened(false)}>
              Cancel
            </Button>
            <Button onClick={handleAddVendor}>Save</Button>
          </Group>
        </Container>
      </Modal>
      <Modal
        opened={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={<Title order={4}>Add New Expense Category</Title>}
        closeOnClickOutside={false}
      >
        <AddNewExpenseAcc
          expensesAccountList={expensesAccountList}
          setIsModalOpen={setIsModalOpen}
          fetchExpenseAccounts={fetchExpenseAccounts}
          setIsPageLoading={setIsPageLoading}
        />
      </Modal>
      <Modal
        opened={modalBankingOpened}
        onClose={() => setModalBankingOpened(false)}
        title={
          <Title order={4} weight={500}>
            Add New Banking Account
          </Title>
        }
        size={"lg"}
        closeOnClickOutside={false}
        closeButtonProps={{
          iconSize: "52",
        }}
      >
        {" "}
        <Container>
          <SimpleGrid style={{ marginTop: "20px" }}>
            <Stack>
              <Title order={4} weight={500}>
                Add Bank or Credit Card
              </Title>
              <Radio.Group
                value={accountType}
                onChange={setAccountType}
                name="accountType"
                label="Select Account Type"
              >
                <Group mt={"md"}>
                  <Radio value="bank_account" label="Bank Account" />
                  <Radio value="credit_card" label="Credit Card" />
                </Group>
              </Radio.Group>

              <TextInput
                label="Account Name"
                placeholder="Enter account name"
                value={accountName}
                onChange={(e) => setAccountName(e.target.value)}
              />

              <TextInput
                label="Nick name"
                placeholder="Enter account code"
                value={nickname}
                onChange={(e) => setNickname(e.target.value)}
              />

              <TextInput
                label="Currency"
                placeholder="INR"
                value={currency}
                readOnly
              />

              <Textarea
                label="Description"
                placeholder="Enter description"
                minRows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />

              <Group mt="md">
                <Button
                  variant="outline"
                  onClick={() => setModalBankingOpened(false)}
                >
                  Cancel
                </Button>
                <Button onClick={saveBankingAccount}>Save</Button>
              </Group>
            </Stack>
          </SimpleGrid>
        </Container>
      </Modal>
      <BenchLoader isLoading={isPageLoading} />
    </div>
  );
}
function AddNewExpenseAcc({
  expensesAccountList,
  setIsModalOpen,
  fetchExpenseAccounts,
  setIsPageLoading,
}: any) {
  const companyId = useAppSelector(
    (state: RootState) => state.session.company_id
  );

  const [accountName, setAccountName] = useState("");
  const [isSubAccount, setIsSubAccount] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState<any>("");
  const [discription, setDiscription] = useState("");

  async function handleAddExpenseAcc() {
    console.log(selectedAccount, "selectedAccount");
    if (accountName === "") {
      showToast.warn("nameRequired");
      return;
    }
    if (!companyId) {
      console.error("companyId is", companyId);
      return;
    }

    try {
      setIsPageLoading(true);
      const expenseAccountData = {
        value: accountName.trim(),
        label: accountName,
        ...(selectedAccount !== "" ? { group: selectedAccount } : {}),
        company_id: companyId,
        description: discription || "",
        created_at: serverTimestamp(),
      };
      // Add the new expense account document
      const docRef = await addDoc(
        collection(db, "companyprofile", companyId, "expenseaccounts"),
        expenseAccountData
      );

      console.log("Expense account added with ID: ", docRef.id);
      fetchExpenseAccounts();
    } catch (error) {
      console.error("Error adding expense account: ", error);
      logError(error, "handleAddExpenseAcc AddTransactionPage");
    } finally {
      setIsModalOpen(false);
      setIsPageLoading(false);
    }
  }

  return (
    <Stack>
      <TextInput
        label="Account Name"
        placeholder="Enter account name"
        onChange={(e) => setAccountName(e.target.value)}
      />

      <div style={{ display: "flex", alignItems: "center" }}>
        <Checkbox
          label="Make this a sub-account"
          checked={isSubAccount}
          onChange={(event) => setIsSubAccount(event.currentTarget.checked)}
        />
        <Tooltip
          label="Check this box if you want to make this a sub-account of an existing expense account."
          withArrow
          position="right"
          withinPortal
        >
          <IconInfoCircle
            size={20}
            stroke={1}
            style={{ marginLeft: 8, cursor: "pointer", color: "gray" }}
          />
        </Tooltip>
      </div>

      {isSubAccount && (
        <Select
          label="Select Parent Expense Category"
          placeholder="Choose an account"
          data={expensesAccountList?.map((account: any) => ({
            value: account?.value,
            label: account?.label,
          }))}
          value={selectedAccount}
          onChange={setSelectedAccount}
          nothingFound
          withinPortal
        />
      )}

      <Textarea
        label="Description"
        placeholder="Enter account description"
        onChange={(e) => setDiscription(e.target.value)}
      />
      <Group position="right" mt="lg">
        <Button variant="outline" onClick={() => setIsModalOpen(false)}>
          Cancel
        </Button>
        <Button onClick={handleAddExpenseAcc}>Add</Button>
      </Group>
    </Stack>
  );
}

// const vendors = [
//   { value: "vendor1", label: "Vendor One" },
//   { value: "vendor2", label: "Vendor Two" },
//   { value: "vendor3", label: "Vendor Three" },
//   { value: "add_new_vendor_account", label: "Add New Vendor Account" },
// ];
const gstOptions = [
  { value: "registered", label: "Registered Business" },
  { value: "unregistered", label: "Unregistered" },
  { value: "overseas", label: "Overseas" },
  { value: "other", label: "Other" },
];
